import styled from "@emotion/styled"

const TextSevenText = styled.div`
  font-weight: normal;
  line-height: 150%;
  font-size: 18px;
`

export default TextSevenText
